import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";
import Switch from "react-switch";
import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
// Redux
import { withRouter, Link } from "react-router-dom";

// Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
  Fn_ChangeStateValue,
} from "../../store/functions";

export const DateString = dd => {
  let d1 = dd.replace("-", "");
  let d2 = d1.replace("-", "");

  return d2;
};

class Screen2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      formData: {},
      activeTab: 1,
      passedSteps: [1],
      BrowseImage1: "",
      BrowseImage2: "",
      UserImage: "",
      Signature: "",
      //dropdowns
      membershipType: [],
      maritalStatus: [],
      bloodGroup: [],
      gender: [],
      education: [],
      profession: [],
      relationShip: [],
      nationality: [],
      typeofRegCert: [],
      memberid: 0,
      name: "",
      email: "",
      aid: 0,
      fo3: false,
      Gender: 0,
      MaritalStatus: 0,
      success_msg: false,
      F_MISScheme: 0,
      IsOvertime: false,
      EmpBasic: [],
      searchText: '',
    };
    this.obj = this;
    this.nameFieldRef = React.createRef();
    this.formTitle = "User";
    this.breadCrumbTitle = "User Master";
    this.breadCrumbItem = "Add " + this.formTitle;
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/User";
    this.API_URL_SAVE = API_WEB_URLS.UserMaster + "/0/token";
    this.pushFormName = "/UserMaster";
    this.rtPage_Print = "/membersynopsisprint";

    //Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnCancel_onClick = this.btnCancel_onClick.bind(this);
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);
  }

  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (this.nameFieldRef.current) {
      this.nameFieldRef.current.focus();
    }
    this.setState({
      name: obj.username,
      email: obj.email,
      aid: obj.uid,
      role: obj.role,
    });
    
    Fn_FillListData(
      this.obj,
      "UserType",
      API_WEB_URLS.MASTER + "/0/token/UserType/Id/0"
    );
    //Filling DropDowns
   
    const { id } = this.props.match.params;
    if (id) {
      this.setState({ id: id });
      this.breadCrumbItem = "Edit " + this.formTitle;
      Fn_DisplayData(this.obj, id, this.API_URL + "/Id");
    } else {
      this.setState({ id: 0 });
    }
  }

  btnSave_onClick(event, formData) {
    let vformData = new FormData();

    vformData.append("Name", formData.Name);
    vformData.append("Password", formData.Password);
    vformData.append("F_UserType", formData.F_UserType);
    vformData.append("UserId", this.state.aid);
    if (!this.state.id) {
      Fn_AddEditData(
        this.obj,
        { arguList: { id: 0, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "memberid"
      );
    } else
      Fn_AddEditData(
        this.obj,
        { arguList: { id: this.state.id, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "kuku"
      );

  }

  btnGoBack_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  btnCancel_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  render() {
    return (
      <div className="page-content">
        <React.Fragment>
          <Container fluid>
            {/* Product Header */}
            <div className="product-header mb-4" style={{ 
              padding: '20px 0',
              borderBottom: '1px solid #eee'
            }}>
              <h4 style={{ 
                fontSize: '24px', 
                color: '#4B4B7C',
                fontWeight: '600',
                marginBottom: '8px'
              }}>
                Product Details
              </h4>
              <p style={{ color: '#666', fontSize: '14px' }}>
                View product information and features
              </p>
            </div>

            <Row className="align-items-stretch">
              {/* Left Side - Account Image and KYC Button */}
              <Col lg="8">
                <Card style={{
                  border: 'none',
                  borderRadius: '15px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                  height: '100%'
                }}>
                  <CardBody className="d-flex flex-column align-items-center justify-content-center">
                    {/* Account Type Box */}
                    <div style={{ 
                      width: '200px',
                      background: '#fff',
                      borderRadius: '12px',
                      padding: '30px',
                      marginBottom: '40px',
                      textAlign: 'center',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
                      border: '1px solid #f0f0f0'
                    }}>
                      <div style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        background: '#f8f9ff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 20px'
                      }}>
                        <i className="mdi mdi-bank font-size-32" 
                           style={{ color: '#4B4B7C' }}></i>
                      </div>
                      <h5 style={{ 
                        color: '#333',
                        marginBottom: '10px',
                        fontSize: '18px',
                        fontWeight: '600'
                      }}>
                        Savings Account
                      </h5>
                      <p style={{ 
                        color: '#666',
                        fontSize: '14px',
                        margin: 0
                      }}>
                        Personal Banking Solution
                      </p>
                    </div>

                    {/* KYC Button */}
                    <Button
                      className="kyc-button"
                      style={{ 
                        backgroundColor: '#4B4B7C',
                        border: 'none',
                        padding: '12px 40px',
                        fontSize: '16px',
                        borderRadius: '8px',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 15px rgba(75,75,124,0.2)'
                      }}
                      onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                      onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                      <i className="mdi mdi-shield-check-outline mr-2"></i>
                      Complete KYC
                    </Button>
                  </CardBody>
                </Card>
              </Col>

              {/* Right Side - Features & Benefits */}
              <Col lg="4">
                <Card style={{
                  background: 'linear-gradient(135deg, #4B4B7C 0%, #3a3a61 100%)',
                  border: 'none',
                  borderRadius: '15px',
                  height: '100%',
                  boxShadow: '0 4px 20px rgba(75,75,124,0.2)'
                }}>
                  <CardBody>
                    <div className="features-header mb-4">
                      <h5 style={{ 
                        color: '#fff',
                        fontSize: '20px',
                        fontWeight: '600',
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <i className="mdi mdi-star-circle mr-2"></i>
                        Features & Benefits
                      </h5>
                    </div>
                    
                    <ul style={{ 
                      listStyle: 'none',
                      padding: 0,
                      margin: 0
                    }}>
                      {[
                        'Specially designed product for freelance customers',
                        'No minimum balance requirement',
                        'No Debit Card facility',
                        'Instant funds transfer to any bank using NEFT facility'
                      ].map((feature, index) => (
                        <li key={index} style={{
                          marginBottom: '15px',
                          display: 'flex',
                          alignItems: 'flex-start',
                          color: '#fff',
                          padding: '10px 15px',
                          borderRadius: '8px',
                          background: 'rgba(255,255,255,0.1)',
                          marginBottom: '10px',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseOver={e => e.currentTarget.style.transform = 'translateX(5px)'}
                        onMouseOut={e => e.currentTarget.style.transform = 'translateX(0)'}
                        >
                          <i className="mdi mdi-check-circle mr-3 mt-1" 
                             style={{ color: '#7fff00' }}></i>
                          <span style={{ fontSize: '14px', lineHeight: '1.5' }}>
                            {feature}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </React.Fragment>
      </div>
    );
  }
}
export default compose(container)(Screen2);
